import React from 'react'
import {
    HiOutlineOfficeBuilding,
    HiOutlineUsers,
    HiOutlineQuestionMarkCircle,
    HiBell,
    // HiOutlineShoppingCart,
    // HiOutlineUsers
} from 'react-icons/hi'
import { BiBasket, BiBuildings, BiExtension } from 'react-icons/bi'
import { TbCoffee } from 'react-icons/tb'
import { GrAppsRounded } from 'react-icons/gr'
import { TbPremiumRights } from 'react-icons/tb'
import { RiUserSettingsLine } from 'react-icons/ri'
// import { TbDiscount } from 'react-icons/tb'
import { LiaUserShieldSolid } from 'react-icons/lia'
// import { TfiLayoutListThumb } from 'react-icons/tfi'
// import { RiUserSettingsLine } from 'react-icons/ri'

const menuItems = [
    { id: 0, label: 'Dashboard', module: 'dashboard', link: '/dashboard', icon: <GrAppsRounded size={20} /> },
    { id: 1, label: 'Companies', module: 'companies', link: '/companies', icon: <HiOutlineOfficeBuilding size={20} /> },
    {
        id: 2,
        label: 'Branch',
        module: 'branch',
        icon: <BiBuildings size={20} />,
        children: [
            { id: 21, label: 'All Branches', module: 'all-branches', link: '/branch/all-branches' },
            { id: 22, label: 'Features', module: 'features', link: '/branch/features' },
            { id: 23, label: 'Services', module: 'services', link: '/branch/services' },
            { id: 24, label: 'Branch Timings', module: 'branch-timings', link: '/branch/branch-timings' },
            { id: 25, label: 'Holidays', module: 'holidays', link: '/branch/holidays' },
        ],
    },
    {
        id: 9,
        label: 'Loyalty',
        module: 'Loyalty',
        icon: <TbCoffee size={20} />,
        children: [
            { id: 91, label: 'Billing Summary', module: 'Loyalty', link: '/loyalty' },
            { id: 92, label: 'Loyalty Tiers', module: 'Loyalty', link: '/loyalty/tiers' },
            { id: 93, label: 'NFC Cards', module: 'Loyalty', link: '/loyalty/nfc-cards' },
            { id: 94, label: 'Settings', module: 'Loyalty', link: '/loyalty/settings' },
            { id: 95, label: 'Loyalty Notifications', module: 'Loyalty', link: '/loyalty/notifications' },
        ],
    },
    { id: 13, label: 'Add-Ons', module: 'addons', link: '/addons', icon: <BiExtension size={20} /> },
    { id: 14, label: 'Notifications', module: 'notifications', link: '/admin/notifications', icon: <HiBell size={20} /> },
    { id: 3, label: 'Roles', module: 'roles', link: '/roles', icon: <RiUserSettingsLine size={20} /> },
    {
        id: 4,
        label: 'Assign Permissions',
        module: 'assign-permissions',
        link: '/assign-permissions',
        icon: <LiaUserShieldSolid size={20} />,
    },
    { id: 5, label: 'Users', module: 'users', link: '/users', icon: <HiOutlineUsers size={20} /> },
    {
        id: 6,
        label: 'Product',
        module: 'product',
        icon: <BiBasket size={20} />,
        children: [
            { id: 61, label: 'Categories', module: 'categories', link: '/product/categories' },
            // { id: 62, label: 'Product Type', module: 'product-type', link: '/product/product-type' },
            // { id: 63, label: 'Tax', module: 'tax', link: '/product/tax' },
            // { id: 64, label: 'Product Categories', module: 'product-categories', link: '/product/product-categories' },
            { id: 65, label: 'All Products', module: 'all-products', link: '/product/all-products' },
            // { id: 66, label: 'Product Subs', module: 'product-subs', link: '/product/product-subs' },
        ],
    },
    {
        id: 7,
        label: 'Subscription',
        module: 'subscription',
        icon: <TbPremiumRights size={20} />,
        children: [
            { id: 71, label: 'Subscription Plans', module: 'stripe', link: '/stripe' },
            { id: 72, label: 'Subscription Rules', module: 'subscription', link: '/subscription' },
            // { id: 73, label: 'Assign Products', module: 'assign-subscription', link: '/assign-subscription' },
            { id: 74, label: 'Product Row', module: 'manage-product-subscription', link: '/manage-product-subscription' },
            // { id: 73, label: 'All Products', module: 'all-products', link: '/product/all-products' },
        ],
    },
    { id: 8, label: 'FAQ', module: 'faq', link: '/faq', icon: <HiOutlineQuestionMarkCircle size={20} /> },
    // { id: 9, label: 'Orders', module: 'orders', link: '/orders', icon: <HiOutlineShoppingCart size={20} /> },
    // { id: 10, label: 'Coupons', module: 'coupons', link: '/coupons', icon: <TbDiscount size={20} /> },
    // {
    //     id: 11,
    //     label: 'Ratings & Reviews',
    //     module: 'ratings-reviews',
    //     link: '/ratings-reviews',
    //     icon: <TfiLayoutListThumb size={20} />,
    // },
    // { id: 12, label: 'Inquiry', module: 'inquiry', link: '/inquiry', icon: <GrHelpBook size={20} /> },
]

export default menuItems
